import {push} from 'react-router-redux';
import _ from 'lodash';
import CHATED from '../../../helpers/chated-client';
import {SS_KEY} from '../../../constants';

export function loginWithShopify(params) {
	return async (dispatch) => {
		// Trial One
		const response = await CHATED.shopify.login({
			callback_payload: params
		});

		const shop = params.shop;

		if (response.meta.code === 200) {
			dispatch(handleSuccessfulAuthentication(response.data.user, response.data.auth, shop));
			return;
		}

		// Trial Two
		const response2 = await CHATED.shopify.login({
			callback_payload: params
		});

		if (response2.meta.code === 200) {
			dispatch(handleSuccessfulAuthentication(response2.data.user, response2.data.auth, shop));
		} else {
			dispatch(handleFailedAuthentication(_.get(params, 'shop')));
		}
	};
}

// action helper methods
export function handleSuccessfulAuthentication(user, auth, shop) {
	return async (dispatch) => {
		// Set token and user to session storage
		window.sessionStorage.setItem(SS_KEY.AUTH_TOKEN, auth.token);
		window.sessionStorage.setItem(SS_KEY.USER, JSON.stringify(user));
		window.sessionStorage.setItem(SS_KEY.APP_SLUG, 'shopify');

		// {
		// 	payment: {
		// 		app_connection_id: appConnection._id,
		// 		product_slug: 'abandoned_cart',
		// 		product_variant_slug: 'default_plan',
		// 		payment_method: 'shopify_recurring_application_charge'
		// 	},
		// 	return_url: config.callback_url.payment
		// }

		// by pass payment if allow_free_usage
		/* allow using the app for free temporarily
		if (!user.allow_free_usage) {
			// Find or create (Refactor if really got someone buying this shit)
			const billingResponse = await CHATED.payment.createShopifyAbandonedCartPayment();
			console.log(billingResponse);
			if (billingResponse.meta.code !== 200) {
				dispatch(push(`/?shop=${shop}`));
				return;
			}
			const payment = billingResponse.data.payment;
			if (payment.status !== 'active') {
				if (payment.status === 'accepted') {
					// go to activation
					dispatch(push(`/callback/payment?shop=${shop}`));
					return;
				}

				// redirect to payment confirmation page
				window.location.replace(payment.confirmation_url);
				return;
			}
		}
		*/

		const response = await CHATED.templateConnection.getAll();
		if (response.meta.code === 200) {
			const templateConnection = _.find(response.data.template_connections, {
				template_slug: 'abandoned_cart'
			});

			if (templateConnection.enabled) {
				// redirect to dashboard
				dispatch(push('/dashboard/checkouts'));
			} else {
				// redirect to settings page
				dispatch(push('/dashboard/emails/settings/general'));
			}
		}
	};
}

export function handleFailedAuthentication(shop) {
	return async (dispatch) => {
		const response = await CHATED.shopify.downloadOAuthUrl({
			shop
		});

		if (response.meta.code === 200) {
			window.location.replace(response.data.auth_url);
		} else {
			dispatch(push('/'));
		}
	};
}



// WEBPACK FOOTER //
// ./src/containers/callback-shopify-page/actions/index.js